import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { episodeOfCareAction } from '../../actions/constant';
import episodeOfCareService from '../../../services/apiServices/episodeOfCare/episodeOfCare';

const {
    GET_EPISODE_OF_CARE_REQUIRED_DOCUMENT_REQUEST,
    GET_EPISODE_OF_CARE_REQUIRED_DOCUMENT_SUCCESS,
    GET_EPISODE_OF_CARE_REQUIRED_DOCUMENT_FAILURE,
} = episodeOfCareAction;

function* getEpisodeOfCareRequiredDocument(payload: any): SagaReturnType<any> {
    try {
        const response = yield call(episodeOfCareService.getEpisodeOfCareRequiredDocument, payload?.payload);
        if (response?.status === 200) {
            yield put({ type: GET_EPISODE_OF_CARE_REQUIRED_DOCUMENT_SUCCESS, payload: response.data });
        } else {
            throw response.data;
        }
    } catch (error) {
        yield put({ type: GET_EPISODE_OF_CARE_REQUIRED_DOCUMENT_FAILURE, payload: error });
    }
}

function* getEpisodeOfCareRequiredDocumentSaga() {
    yield takeEvery(GET_EPISODE_OF_CARE_REQUIRED_DOCUMENT_REQUEST, getEpisodeOfCareRequiredDocument)
}

export default getEpisodeOfCareRequiredDocumentSaga;
